import React from 'react'
import PropTypes from 'prop-types'

const Spinner = ({ color = 'gray', style }) => {
  return (
    <div className={`loading-spinner ${color}`} style={style}>
      <div className='spinner-container container1'>
        <div className='circle1' />
        <div className='circle2' />
        <div className='circle3' />
        <div className='circle4' />
      </div>
      <div className='spinner-container container2'>
        <div className='circle1' />
        <div className='circle2' />
        <div className='circle3' />
        <div className='circle4' />
      </div>
      <div className='spinner-container container3'>
        <div className='circle1' />
        <div className='circle2' />
        <div className='circle3' />
        <div className='circle4' />
      </div>
    </div>
  )
}

Spinner.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object
}

export default Spinner
